import { useReduxState } from 'hooks';
import { Avatar, Link } from 'components/common';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  category: 'danger' | 'default' | 'warning';
  className?: string;
  href: string;
  icon: IconProp;
  label: string;
  value: number;
}

const MyTeamNotificationsItem = ({
  category,
  href,
  icon,
  label,
  value
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="item-wrapper">
      <Link href={href}>
        <div className={`item ${value ? '' : 'item-inactive'}`}>
          <div className="icon">
            <Icon icon={icon} />
          </div>
          <div className="label">{label}</div>
          <div className="count">
            <Avatar
              backgroundColor={
                {
                  danger: theme.dangerLightColor,
                  default: theme.lightGrey,
                  warning: theme.warningLightColor
                }[value ? category : 'default']
              }
              color={
                {
                  danger: theme.dangerLightTextColor,
                  default: theme.textColorLight,
                  warning: theme.warningLightTextColor
                }[value ? category : 'default']
              }
              fontSize="1.5rem"
              padding="4px 0"
            >
              {(value || 0).toString()}
            </Avatar>
          </div>
        </div>
      </Link>

      <style jsx>{`
        .item-wrapper:not(:first-child) {
          border-top: 1px solid ${theme.lightGreyDark};
        }
        .item {
          align-items: center;
          display: flex;
          gap: 10px;
          padding: 10px 15px;
          text-decoration: none;
        }
        .icon {
          color: ${theme.textColorLight};
          font-size: 1.3rem;
        }
        .label {
          color: ${theme.textColorLight};
          flex-grow: 1;
          font-size: 1.5rem;
          font-weight: 600;
        }
        .item-inactive .icon,
        .item-inactive .label,
        .item-inactive .count {
          opacity: 0.5;
        }
      `}</style>
    </div>
  );
};

export default MyTeamNotificationsItem;
